//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "commonUrlTips",
  data(){
    return {
      showLayer: true
    }
  },
  methods: {
    closeNotice(){
      this.showLayer = false;
      localStorage.removeItem("from");
      location.reload();
    },
    /*clickCollect(){
      const title = document.title;
      const url = window.location.href;
      // 对于WebKit浏览器
      if (window.sidebar && window.sidebar.addPanel) {
        window.sidebar.addPanel(title, url, "");
      }
      // 对于IE
      else if (window.external && ('AddFavorite' in window.external)) {
        window.external.AddFavorite(url, title);
      }
      // 对于其他浏览器
      else {
        alert("请使用 " + (navigator.userAgent.toLowerCase().indexOf('mac') != -1 ? 'Command/Cmd' : 'Ctrl') + " + D 来收藏本页");
      }
    }*/
  }
}
